import { render, staticRenderFns } from "./verArticulos.vue?vue&type=template&id=5002e1f8"
import script from "./verArticulos.vue?vue&type=script&lang=js"
export * from "./verArticulos.vue?vue&type=script&lang=js"
import style0 from "./verArticulos.vue?vue&type=style&index=0&id=5002e1f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports